"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteData = exports.patchFormData = exports.patchData = exports.putData = exports.postFormData = exports.postData = exports.getData = void 0;
const axios_1 = __importDefault(require("axios"));
const functions_1 = require("@/common/functions");
const headers = () => ({
    'X-CSRFToken': (0, functions_1.getCookie)('csrftoken'),
    withCredentials: true,
});
const formHeaders = () => ({
    'X-CSRFToken': (0, functions_1.getCookie)('csrftoken'),
    'Content-Type': 'application/x-www-form-urlencoded',
    withCredentials: true,
});
function getData(url) {
    return axios_1.default.get(url);
}
exports.getData = getData;
function postData(url, data) {
    return axios_1.default.post(url, data, { headers: headers() });
}
exports.postData = postData;
function postFormData(url, data) {
    return axios_1.default.post(url, data, { headers: formHeaders() });
}
exports.postFormData = postFormData;
function putData(url, data) {
    return axios_1.default.put(url, data, { headers: headers() });
}
exports.putData = putData;
function patchData(url, data) {
    return axios_1.default.patch(url, data, { headers: headers() });
}
exports.patchData = patchData;
function patchFormData(url, data) {
    return axios_1.default.patch(url, data, { headers: formHeaders() });
}
exports.patchFormData = patchFormData;
function deleteData(url) {
    return axios_1.default.delete(url, { headers: headers() });
}
exports.deleteData = deleteData;
